var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1336_7769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0576 6.79791L19.5434 1.58115C18.9569 1.02626 18.1892 0.720703 17.3818 0.720703H6.88347C5.14915 0.720703 3.73816 2.13169 3.73816 3.86602V26.8554C3.73816 28.5897 5.14915 30.0007 6.88347 30.0007H22.896C24.6303 30.0007 26.0413 28.5897 26.0413 26.8554V9.08278C26.0413 8.22217 25.6827 7.38934 25.0576 6.79791ZM23.3913 7.58321H19.1216C18.9639 7.58321 18.8357 7.45494 18.8357 7.29727V3.27333L23.3913 7.58321ZM22.896 28.2851H6.88347C6.09514 28.2851 5.45379 27.6437 5.45379 26.8554V3.86602C5.45379 3.07769 6.09514 2.43633 6.88347 2.43633H17.12V7.29727C17.12 8.40093 18.0179 9.29884 19.1216 9.29884H24.3257V26.8554C24.3257 27.6437 23.6843 28.2851 22.896 28.2851Z",
    fill: "#317289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0089 12.1582H8.42764C7.9539 12.1582 7.56982 12.5423 7.56982 13.016C7.56982 13.4898 7.9539 13.8738 8.42764 13.8738H21.0089C21.4826 13.8738 21.8667 13.4898 21.8667 13.016C21.8667 12.5423 21.4826 12.1582 21.0089 12.1582Z",
    fill: "#317289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0089 16.7324H8.42764C7.9539 16.7324 7.56982 17.1165 7.56982 17.5902C7.56982 18.064 7.9539 18.448 8.42764 18.448H21.0089C21.4826 18.448 21.8667 18.064 21.8667 17.5902C21.8667 17.1165 21.4826 16.7324 21.0089 16.7324Z",
    fill: "#317289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5863 21.3066H8.42764C7.9539 21.3066 7.56982 21.6907 7.56982 22.1645C7.56982 22.6382 7.9539 23.0223 8.42764 23.0223H12.5863C13.0601 23.0223 13.4441 22.6382 13.4441 22.1645C13.4441 21.6907 13.0601 21.3066 12.5863 21.3066Z",
    fill: "#317289"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1336_7769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.28,
    height: 29.28,
    fill: "white",
    transform: "translate(0.249756 0.720703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.09fb46382530e0bea8c1d9310adef9a7.svg";
export { ForwardRef as ReactComponent };